import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { getTableCode } from './helpers';
import { FinalizeOrderType, Store } from './types';
import * as Api from './Api';
import { enqueueNotification } from './actions/Actions';

const TableOrder: React.FC = () => {
    const selectedTableOrder = useSelector(({ app }: Store) => app.selectedTableOrder);
    const tables = useSelector(({ app }: Store) => app.tables);
    const products = useSelector(({ app }: Store) => app.products);
    const dispatch: ThunkDispatch<Store, unknown, AnyAction> = useDispatch();

    const handleTableOrder = React.useCallback(() => {
        Api.finalizeOrder(
            selectedTableOrder.orderItems.map(({ id }) => id),
            FinalizeOrderType.PayTable
        ).then(res => {
            if (res) {
                dispatch(
                    enqueueNotification({
                        key: new Date().getTime(),
                        message: res,
                        options: { variant: 'error' }
                    })
                );
            }
        });
    }, [dispatch, selectedTableOrder?.orderItems]);

    const renderOrder = React.useCallback(
        () =>
            selectedTableOrder.orderItems.map(
                ({ quantity, productVarietyID, comments, productID }, id) => {
                    const { productVarieties, name } = products.find(
                        p => p.id === productID
                    );
                    const variety = productVarieties.find(
                        v => v.id === productVarietyID
                    );

                    return (
                        <div className='order-item' key={id}>
                            <div className='top'>
                                <div className='name'>{name}</div>
                                <div>x{quantity}</div>
                            </div>
                            {variety && variety.name}
                            {comments && <div className='comments'>{comments}</div>}
                        </div>
                    );
                }
            ),
        [products, selectedTableOrder?.orderItems]
    );

    if (!selectedTableOrder?.orderItems?.length) {
        return null;
    }

    return (
        <div className='table-order'>
            <div className='table-id'>
                ΤΡΑΠΕΖΙ {getTableCode(tables, selectedTableOrder.tableID)}
            </div>
            <div className='orders'>{renderOrder()}</div>
            <button type='button' onClick={handleTableOrder}>
                Πληρωμή
            </button>
        </div>
    );
};

export default TableOrder;
